export const CODE_MIRROR_OPTIONS = {
    JSON_SPACE: 4
};

export default CODE_MIRROR_OPTIONS;